import * as React from "react";
import { Edit, SimpleForm, TextInput, List, Datagrid, TextField, DateField, Create, BooleanField, BooleanInput } from 'react-admin';

const ShootUnitsTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const ShootUnitsList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="code" />
            <TextField source="name" />
            <BooleanField source="is_active" label="Active" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);

export const ShootUnitsEdit = props => (
    <Edit {...props} title={<ShootUnitsTitle />} undoable={false}>
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <BooleanInput source="is_active" label="Active" />
        </SimpleForm>
    </Edit>
);

export const ShootUnitsCreate = props => (
    <Create {...props} title={<ShootUnitsTitle />} undoable={false} redirect="list">
        <SimpleForm redirect="list">
            <TextInput source="code" />
            <TextInput source="name" />
            <BooleanInput source="is_active" label="Active" />
        </SimpleForm>
    </Create>
);